<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="ORIM-Book-Title--Front-Matter-">The Darling Buds of May</p>
<p class="ORIM-Book-Subtitle--Front-Matter-">The Pop Larkin Chronicles</p>
<p class="ORIM-Author-Name--Front-Matter-">H. E. Bates</p>
<p class="ORIM-Author-Name--Front-Matter-"><img src="image/fig_02.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TheDarlingBudsOfMay1.vue?4d954d8e